import { HttpClient } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { CallRequest, WidgetConfiguration } from '../models';

export const WIDGET_API_URL = new InjectionToken<string>('WIDGET_API_URL');

@Injectable()
export class WidgetService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(WIDGET_API_URL);

  public getConfig(widgetId: string): Observable<WidgetConfiguration> {
    return this.http.get<WidgetConfiguration>(`${this.apiUrl}/public/widgets/${widgetId}/config`);
  }

  public createCallRequest(widgetId: string, request: CallRequest): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/public/widgets/${widgetId}/call-requests`, request);
  }
}
